 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		104: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"ApproveRoutes~Billing~CollectionList~Dashboard-components-Drawers-StaffCheckinPhoto~Dashboard-compon~e64fc251","2":"Approve~Billing~CollectionList~OrderApproval~OrderPending~ProformaInvoice~Reconcile~Summary~SupplyLi~7ec7a77b","3":"Dashboard-components-Drawers-TransactionDetail~Transactions-components-AddTransaction~pages-Transact~a14ff732","4":"Summary~SummaryTable~SummaryTableGroupView~pages-Statements","5":"ApproveRoutes~Billing~Root Drawers","6":"Approve~CollectionList~SupplyList","7":"Collection~Dashboard-components-Drawers-Settings~pages-Transactions-TransactionsContainer","8":"Collection~DashboardLeftContainer~pages-Transactions-TransactionsContainer","9":"Root Drawers~Transactions-components-AddTransaction~pages-Transactions-components-AddTransaction","10":"AuthChunk~PaltformUnsupportedChunk","11":"Collection~DashboardLeftContainer","12":"DepositCash~Reconcile","13":"OrderApproval~OrderPending","14":"PendingActionDrawer~TableCustomerDetails","15":"UploadedDocumentSection~pages-Payments","16":"AddAddressChunk","17":"AddCustomerDetails","18":"AddCustomersToList","19":"AddCustomersToList-AddToCustomersV2","20":"AddToList","21":"AddToTransectionDrawer","22":"AddedStaffDrawer","23":"Advertisement","24":"Approve","25":"ApproveAllCollection","26":"ApproveRoutes","27":"AssignStaffDrawer","28":"AuthChunk","29":"AutoAssignmentCard","30":"AutoTagListDrawer","31":"Billing","32":"BlindPayChunk","33":"BlindPayClaimedChunk","34":"BlindPayExpiredChunk","35":"BlindPaySuccessChunk","36":"BlockPage","37":"Collection","38":"CollectionList","39":"CollectionListItem","40":"ConfirmOrderChunk","41":"CustomerDetailsCard","42":"CustomerListItem","43":"Dashboard-components-AddCustomerSupplierPopup","44":"Dashboard-components-AddCustomerSupplierSuccessPopup","45":"Dashboard-components-Drawers-Beats-AccountBeats","46":"Dashboard-components-Drawers-Beats-AccountRoutes","47":"Dashboard-components-Drawers-CustomerSupplierProfileEditor","48":"Dashboard-components-Drawers-MerchantProfileEditor","49":"Dashboard-components-Drawers-Reminder","50":"Dashboard-components-Drawers-Settings","51":"Dashboard-components-Drawers-StaffCheckinPhoto","52":"Dashboard-components-Drawers-StaffSettings","53":"Dashboard-components-Drawers-StaffSettingsDistanceTravelled","54":"Dashboard-components-Drawers-SwitchAccount","55":"Dashboard-components-Drawers-Tags-AccountTags","56":"Dashboard-components-Drawers-Tags-TagManagement","57":"Dashboard-components-Drawers-TransactionDetail","58":"DashboardChunk","59":"DashboardLeftContainer","60":"DepositCash","61":"DocumentAssignToMultipleStaffLinks","62":"DocumentAssignToStaffLink","63":"DocumentFormatConfigure","64":"EnterBusinessModal-EnterBusinessModal","65":"Filter","66":"Header","67":"HeaderCard","68":"HoldItems","69":"IntroSlider","70":"Kyc","71":"ListHeader","72":"ListVersionSelector","73":"MobileBlockPage","74":"OnboardingDashboardChunk","75":"OrderApproval","76":"OrderPending","77":"OrderQRChunk","78":"PaidSoonModel-PaidSoonModel","79":"PaltformUnsupportedChunk","80":"PendingActionDrawer","81":"ProformaInvoice","82":"QROrderStatusChunk","83":"Reconcile","84":"ReminderForm","85":"RemoveCollectionListDrawer","86":"ReplacementsList","87":"Root Drawers","88":"SelectCollectionListTypeDrawer","89":"ShiftCollectionListDrawer","90":"SideDrawer","91":"StaffLinkChunk","92":"SubscriptionBlockPage","93":"SuccessDrawer","94":"Summary","95":"SummaryDrawer","96":"SummaryTable","97":"SummaryTableGroupView","98":"SupplyList","99":"TableCustomerDetails","100":"Transactions-components-AddTransaction","101":"UnidentifiedCollections","102":"UploadedDocumentSection","103":"VerifyOTPChunk","105":"components-CustomPopup","106":"components-HelpSection","107":"components-MyPlan","108":"components-RecordReplacement","109":"components-RemoveTxnPopup","110":"components-TxnAdvanceRemovePopup","111":"pages-CollectionList","112":"pages-CollectionSummary","113":"pages-Payments","114":"pages-Statements","115":"pages-Transactions-TransactionsContainer","116":"pages-Transactions-components-AddTransaction","117":"staffLinkAddOrder","118":"staffLinkOrderCartHistory","119":"staffLinkOrderHistory","120":"staffLinkSelectCustomer","121":"staffLinkViewCardOrder","122":"txn-seed"}[chunkId]||chunkId) + "." + {"1":"be891ef8","2":"88282a61","3":"1bf9613a","4":"75bffa86","5":"247d8b53","6":"af56f92b","7":"9d8ef4bf","8":"ce8679ef","9":"800a48e7","10":"f477019c","11":"aae12f99","12":"270e6537","13":"6e151339","14":"9ee49718","15":"9afc7310","16":"be461383","17":"853a2130","18":"88fcb855","19":"66cb1de1","20":"8a12cf3c","21":"98c63fe7","22":"6faee2ab","23":"d7c7a913","24":"c5a22464","25":"c76d5617","26":"9b19ada7","27":"f021bc2d","28":"e1cc4203","29":"b8f736e6","30":"89271374","31":"2fb44fb7","32":"f1174109","33":"7f79a3a3","34":"33b5111e","35":"59a2f82c","36":"80f6d127","37":"25f4b95c","38":"cb24995e","39":"ef77f36f","40":"3bc95daf","41":"f1d16e0e","42":"830ae8ba","43":"10276a18","44":"345f1bcc","45":"bb92e3f0","46":"9e821754","47":"a7cddcc5","48":"534283e7","49":"b91359b9","50":"ad1096a3","51":"34b8ed0a","52":"e2456958","53":"e94c1028","54":"12c9ef38","55":"3f1f140f","56":"02d3f3c5","57":"fc3c6bf9","58":"d33772b5","59":"09798c03","60":"d9a86654","61":"54b6267a","62":"3d14a2e5","63":"ff11cbb8","64":"5ca65929","65":"a0ab2f0c","66":"7634a882","67":"ed4b8af7","68":"588cfc98","69":"0adb0678","70":"49e7fe45","71":"41d3e3b7","72":"b3afaf9c","73":"9fbf1e27","74":"067067ca","75":"145b3984","76":"f6c211eb","77":"208cf2a2","78":"bc2703ee","79":"f784a61e","80":"273ff5a6","81":"93f11ca8","82":"4fed13c3","83":"698b61a0","84":"dc244c8a","85":"f8426cdc","86":"1b9e168a","87":"7c88e07a","88":"7942497b","89":"bb9f5e6b","90":"00dd926b","91":"1292031f","92":"fc02cc34","93":"d3dea807","94":"8c5e4a79","95":"7853ce53","96":"fb61f712","97":"b0fbb2e5","98":"8f7d3fe0","99":"a8de8ce9","100":"59a4ea87","101":"f8ff8943","102":"8e14aca9","103":"3231679d","105":"dcb689b1","106":"aae75919","107":"f0d0f3d4","108":"0b32fd10","109":"0c610b3d","110":"667ea49a","111":"ea727eaa","112":"f8d382cb","113":"26226200","114":"07bd1c59","115":"ee2580e1","116":"40459ed6","117":"b3a6961f","118":"f059c536","119":"9a5bfe7b","120":"0cbf0bb5","121":"f919223c","122":"096f7324"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
